import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * Small utility component that scrolls the window to the top whenever the route changes.
 * Mount this inside a <BrowserRouter> so all navigations reset the scroll position.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top-left. Using instant behavior so layout doesn't animate unexpectedly.
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }

    // For accessibility, attempt to move focus to the main content if present
    const main = document.querySelector('main') as HTMLElement | null;
    if (main) {
      main.setAttribute('tabindex', '-1');
      main.focus();
    }
  }, [pathname]);

  return null;
};
